import React, { useState } from "react";
import { ImNewTab } from "react-icons/im";
import { TbReload } from "react-icons/tb";
import { useLanguage } from "../Translations/LenguageContext";

const WebPreview = ({
    show,
    handleClose,
    selectedLink,
    setSelectedLink
}) => {
    const { t } = useLanguage();

    const [reloadKey, setReloadKey] = useState(0);
    const [iframeError, setIframeError] = useState(false);

    const handleReload = () => {
        setIframeError(false);
        setReloadKey(prev => prev + 1);
    };

    const handleOpenNewTab = () => {
        if (selectedLink) {
            window.open(selectedLink, "_blank", "noopener,noreferrer");
        }
    };

    const closeSearch = () => {
        handleClose();
        setSelectedLink(null);
    };

    const handleIframeError = () => {
        setIframeError(true);

        // Automatically open blocked websites in a new tab
        if (selectedLink) {
            window.open(selectedLink, "_blank", "noopener,noreferrer");
        }
    };

    return (
        <div className={`sidebar_right_cont ${show ? "sidebar_right_cont_show" : ""}`}>
            <div className="sidebar_right_close" onClick={closeSearch}></div>

            <div className="sidebar_right_main">
                <div className="sidebar_right_main_header">
                    <p>{t.playground.web_search}</p>

                    <div style={{ display: "flex", gap: 10 }}>
                        <button onClick={closeSearch}>
                            <i className="fa-solid fa-x"></i>
                        </button>
                    </div>
                </div>

                <div className="sidebar_right_main_body_web">
                    <div className="link_cont">
                        <p className="link_cont_inner">{selectedLink}</p>

                        <div className="link_cont_inner_btn_cont">
                            <button
                                onClick={handleReload}
                                className="link_cont_inner_btn"
                            >
                                <i><TbReload /></i>
                            </button>

                            <button
                                onClick={handleOpenNewTab}
                                className="link_cont_inner_btn"
                            >
                                <i><ImNewTab /></i>
                            </button>
                        </div>
                    </div>

                    {selectedLink ? (
                        <>
                            <iframe
                                key={reloadKey}
                                src={selectedLink}
                                title="Web Preview"
                                onError={handleIframeError}
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    border: "none",
                                    display: iframeError ? "none" : "block"
                                }}
                                sandbox="
                                    allow-scripts
                                    allow-same-origin
                                    allow-forms
                                    allow-popups
                                    allow-popups-to-escape-sandbox
                                    allow-modals
                                    allow-downloads
                                    allow-presentation
                                    allow-top-navigation-by-user-activation
                                "
                            />

                            {iframeError && (
                                <div
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        flexDirection: "column",
                                        gap: 12,
                                        padding: 20,
                                        textAlign: "center"
                                    }}
                                >
                                    <p>
                                        This website cannot be displayed inside the app.
                                    </p>

                                    <button
                                        onClick={handleOpenNewTab}
                                        className="link_cont_inner_btn"
                                    >
                                        Open in new tab
                                    </button>
                                </div>
                            )}
                        </>
                    ) : (
                        <p>{t.playground.no_links}</p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default WebPreview;